// extracted by mini-css-extract-plugin
module.exports = {"currentPage":"Pagination_currentPage__1W46q","paginationIem":"Pagination_paginationIem__10a1-"};